import React from 'react'
import ReactDOM from 'react-dom'
import Widget from './Components/Widget'

ReactDOM.render(<Widget />, document.querySelector('#root'))